module.exports = __webpack_public_path__ + "img/fourwaves-dark-full.8429c2b.png";